import { cx } from '@twind/core';

import { Copy } from '../Typography';
import LeftArrowIcon from '../icons/LeftArrowIcon';

export default function BackButton({
  onClick,
  label = 'back',
  className,
}: {
  onClick: () => void;
  label?: string;
  className?: string;
}) {
  return (
    <Copy
      id="ostro-webchat-back-button"
      component="button"
      className={cx('~(flex cursor-pointer shrink-0 items-center font-normal p-2)', className)}
      onClick={onClick}
    >
      <LeftArrowIcon className="-ml-2" /> {label}
    </Copy>
  );
}
